export const SET_AddPersonalData = "SET_AddPersonalData";